"use strict";
/* eslint-disable quotes */
const intl = require('@lemonone/intl/lib/en');
module.exports = Object.assign({}, intl, {
    '@lemonone/components/Footer:info': '<a>Homeday GmbH</a>, Prinzessinnenstraße 26, 10969 Berlin Berlin\nMade ❤️ in Berlin',
    '@lemonone/components/Footer:white-label:info': 'Sent on behalf of {name}\nby <a>Homeday GmbH</a>, Prinzessinnenstraße 26, 10969 Berlin Berlin\nMade with 🍋 and ❤️ in Berlin',
    '@lemonone/components/TextArea:placeholder': 'Message',
    '@lemonone/components/Uploader:reupload': 'Reupload',
    '@lemonone/components/Offer:distance': '{distance} km, {duration} mins away from your address',
    '@lemonone/components/Offer:earnings': 'You will earn: {earnings}',
    '@lemonone/components/Offer:compensationContract': '<bold>including</bold> travel cost compensation according to §2 of your contract, otherwise §13 of the <terms>AGB</terms>',
    '@lemonone/components/Offer:compensationContract:text': '*including* travel cost compensation according to §2 of your contract, otherwise §13 of the AGB ({terms})',
    '@lemonone/components/Offer:equipment': 'Minimum required equipment',
    '@lemonone/components/Offer:accept': 'Accept photoshoot',
    '@lemonone/components/Offer:youNeedToProduce': 'You need to produce',
    '@lemonone/components/MoreShootsBanner:wantToSeeMore': 'Want to earn more?',
    '@lemonone/components/MoreShootsBanner:seeOtherShoots': 'See other shoots close by <here>here</here>',
    '@lemonone/components/MoreShootsBanner:seeOtherShoots:text': 'See other shoots close by here ({here})',
    '@lemonone/components/ShootRating:title': 'Please rate your photoshoot experience (Typeform)'
});
//# sourceMappingURL=en.js.map